import { render, staticRenderFns } from "./level-progress-v2.vue?vue&type=template&id=06bfcaac&scoped=true"
import script from "./level-progress-v2.vue?vue&type=script&lang=js"
export * from "./level-progress-v2.vue?vue&type=script&lang=js"
import style0 from "./level-progress-v2.vue?vue&type=style&index=0&id=06bfcaac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bfcaac",
  null
  
)

export default component.exports